import { ObjectMapper } from 'json-object-mapper';
import { IModel } from '../../IModel';
import { Model } from '../../model';

export class ActionPlanTypeModel extends Model implements IModel<ActionPlanTypeModel> {
  public title: string = '';
  public source: string = '';

  static create(input: any): ActionPlanTypeModel {
    return ObjectMapper.deserialize<ActionPlanTypeModel>(ActionPlanTypeModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
